export const LIST_CHECKOUT = 'LIST_CHECKOUT';
export const SHOW_CHECKOUT = 'SHOW_CHECKOUT';
export const RELOAD_CHECKOUT = 'RELOAD_CHECKOUT';
export const UPDATE_CHECKOUT = 'UPDATE_CHECKOUT';
export const DELETE_CHECKOUT = 'DELETE_CHECKOUT';
export const SEND_NOTIFICATION_CHECKOUT = 'SEND_NOTIFICATION_CHECKOUT';